var app_popup = null;

(function ($) {
    'use_strict';

    app_popup = function (_app) {

        var self = this;
        var app = _app;
        var settings = app.settings;
        var element = $('#hoverpop');
        var timeOut;
        var mouse_position_x;
        var mouse_position_y;

        /**
         * init
         * @returns {undefined}
         */
        self.init = function () {
            $(window).on("mousemove", self.mousemove);
        };
        
        self.setElemet = function(){
            element = $("body").find('#hoverpop');
        };

        /**
         * Show pop up
         * @param {Object} data
         * @returns {undefined}
         */
        self.showPopUp = function (data) {
            
            self.setElemet(); 
            
            var htmlString = '';
            var htmlStringLeft = '';
            var htmlStringRight = '';  
            if (data) {

                htmlString += '<h4>' + data.name + '</h4>'; 

                //Build Left,
                htmlStringLeft += '<div class="left">';
                htmlStringRight += '<div class="right">';

                if (data.floor) {
                  htmlStringLeft += "Lgh nr:<br/>";
                  htmlStringRight += data.name + "<br/>";
                }

                if (data.floor) {
                    htmlStringLeft += "Våning:<br/>";
                    htmlStringRight += data.floor + '<br/>';
                }
                


                if (data.rooms.length > 0) {
                    htmlStringLeft += 'Rum:<br/>';
                    htmlStringRight += data.roomsDisplay + '<br/>';
                }
                


                if (data.size > 0) {
                    htmlStringLeft += 'Boarea:<br/>';
                    


                    var bi_size = '';

                    if (settings.theme !== 'viste' && settings.theme !== 'fjallet') {
                        if(data.bi_size > 0){
                            bi_size = ' + ' + data.bi_size.replace(".", ",") + " kvm";
                        } 
                    }

                    htmlStringRight += data.size.replace(".", ",") + ' kvm' + bi_size + '<br/>';
                    
                }  

                if (data.yard_size > 0) {
                    htmlStringLeft += 'Tomtarea:<br/>';

                    htmlStringRight += data.yard_size.replace(".", ",") + ' kvm<br/>';

                }  
                if (data.price > 0) {
                    if (settings.theme === 'rio' && data.available === 'available') {
                        htmlStringLeft += 'Pris:<br/>';
                        htmlStringRight += 'Kontakta mäklare<br/>';
                    }else{
                        htmlStringLeft += 'Pris:<br/>';
                        if(data.price_text == ""){
                            htmlStringRight += addCommas(data.price, data.available) + ' kr<br/>';
                        }else{
                            htmlStringRight += data.price_text + '<br/>';
                        }
                    }
                    
                }
                if (data.fee > 0) {
                    htmlStringLeft += 'Avgift:<br/>';
                    htmlStringRight += addCommas(data.fee, data.available) + ' kr<br/>';
                }
                if (data.extra_fee > 0) {
                    htmlStringLeft += "Serviceavgift:<br/>";
                    htmlStringRight += addCommas(data.extra_fee, data.available) + ' kr<br/>';
                }

                htmlStringLeft += 'Status:';
                htmlStringLeft += '</div>';
                htmlStringRight += app.statusTranslate(data.available);  
                htmlStringRight += '</div>';  
                
                // var d = '';
                // if('' !== data.descriptionShort){
                //     d = '<br><br><strong style="margin-top:15px!important; display:inline-block;">Beskrivning</strong><br><p>' + data.descriptionShort + '</p>';
                // } 
                 
                var d = "<br><br><strong>Klicka för mer information</strong><br>";

                htmlString += htmlStringLeft + htmlStringRight + d;

                if ($(window).outerWidth() < 768) {
                    //htmlString += '<a href="'+data.url+'">Läs mer</a>';    
                }

            } else {
                //REMOVE ME LATER
                htmlString += '<h4 style="text-align:center; margin-bottom:0px;">Kommande</h4>';
                // htmlString += '<h4>Inte tillgänglig</h4>';

            }
            element.html(htmlString);
            element.css({'display': 'block', 'opacity': 1});
            clearTimeout(timeOut);
        };

        /**
         * Showpopup info
         * @param {int} id
         * @returns {undefined}
         */
        self.showPopUpInfo = function (id) {
            self.setElemet();
            var htmlString = '';
            var data = self.get_info(id);

            if (data) {
                htmlString += '<h4>' + data.rubrik + '</h4>';

                //Build Left,
                htmlString += '<div class="text">';
                htmlString += data.text;
                htmlString += '</div>';

            } else {
                //REMOVE ME LATER
                htmlString += '<h4>Kommande</h4>';
                //htmlString += '<h4>Inte tillgänglig</h4>';
            }

            element.html(htmlString);
            element.css({'display': 'block', 'opacity': 1});

            clearTimeout(timeOut);

        };

        /*
         * Hide popup
         */
        self.hidePopUp = function () {
            self.setElemet();
            element.css({'opacity': 0});
            timeOut = setTimeout(function () {
                element.hide();
            }, 1);
        };

        /**
         * Get info
         * @param {int} id
         * @returns {settings.info|Boolean}
         */
        self.get_info = function (id) {
            if (!undef(settings.info) && !undef(settings.info[id])) {
                return settings.info[id];
            }
            return false;
        };

        /**
         * Mouse move funtion
         * @param {type} event
         * @returns {undefined}
         */
        self.mousemove = function (event) {
            self.setElemet(); 
            mouse_position_x = event.pageX;
            mouse_position_y = event.pageY;
            var extraLeft = 0;
            var extraTop = 0;
            var ww = $(window).outerWidth();
            var views = $("body").find(".views");

            if (mouse_position_x < (ww / 2)) {
                extraLeft = 80; 
            } else {
                extraLeft = -280; 
            }
            if (mouse_position_y < (ww / 2)) {
                extraTop = 20; 
            } else {
                extraTop = 20;  
            }
 

            if (views.length > 0) {
                var ll = mouse_position_x + extraLeft - parseInt(views.offset().left);

                if (ww > 768) {
                    element.css({'left': ll, 'top': mouse_position_y + extraTop - parseInt(views.offset().top) - 20});
                } else {
                    if (ll < 0) {
                        element.css({'left': 0, 'top': mouse_position_y + extraTop - parseInt(views.offset().top) - 20});
                    } else {
                        element.css({'left': ll, 'top': mouse_position_y + extraTop - parseInt(views.offset().top) - 20});
                    }

                }
            }
        };
 
        self.init();

        return self;
    };

})(jQuery);  